import { newNotification } from '../../../../core/modules/common/redux/actions/NotificationActions';
import * as NotificationTypes from '../../../../core/modules/common/components/NotificationTypes';
import { REMOVE_NOTIFICATION } from './types/CapeActionTypes';

export const errorNotification = message => newNotification({
  type: NotificationTypes.ERROR,
  text: message,
});
export const warningNotification = message => newNotification({
  type: NotificationTypes.WARNING,
  text: message,
});
export const successNotification = message => newNotification({
  type: NotificationTypes.SUCCESS,
  text: message,
});

export const removeNotification = () => ({
  type: REMOVE_NOTIFICATION,
  payload: {},
});
